export default {
  SettingLabel: "Kết nối dịch vụ",
  SettingDes:
    "JETPAY đã hỗ trợ tích hợp với các Website, Ứng dụng dưới đây. Vui lòng kết nối để trải nghiệm ngay các dịch vụ",
  MerchantCode: "MerchantCode (Mã đơn vị)",
  CheckSumKey: "CheckSumKey (Khóa bảo mật)",
  TerminalID: "Terminal ID (Mã điểm thu)",
  WebsiteName: "Tên website",
  WebsiteNameDetail: "Tên trang web bán hàng",
  Webhook: "Webhook thanh toán qua thẻ",
  Domain: "Website bán hàng",
  DomainLabel: "Cung cấp đường dẫn Website bán hàng của bạn",
  DomainPlaceholder: "Nhập đường dẫn website bán hàng",
  Logo: "Logo",
  LogoUnit: "Logo đơn vị",
  LogoSetting: "Thiết lập logo",
  LogoFormat: "- Định dạng: *.png, *.jpg, *.pdf, *.heic",
  LogoSize: "- Kích thước tối đa 150kb",
  LogoChooseFile: "Chọn tệp",
  LogoSaveSuccess: "Cập nhật logo thành công",
  WebsiteSaveSuccess: "Lưu thông tin thành công",
  Setting: "Thiết lập",
  Connect: "Kết nối",
  InfoSetting: "Thông tin thiết lập",
  InfoSettingToolTip: "Dùng trong phần thông tin cấu hình của tài liệu kết nối kỹ thuật",
  InfoWebhookToolTip: "Dùng để nhận kết quả giao dịch mã QR",
  InfoWebhookQRToolTip: "Dùng để nhận kết quả giao dịch qua thẻ",
  InfoProvidedJetPay: "Thông tin cần cung cấp cho JETPAY",
  Update: "Cập nhật",
  MisaEshopLable: "MISA eShop",
  MisaEshopDes: "Quản lý cửa hàng",
  MisaEshopMes: "Sao chép thông tin sau vào phần phương thức và dịch vụ thanh toán trên trang ",
  MisaMeinvoiceLable: "MISA meInvoice",
  MisaMeinvoiceDes: "Hóa đơn điện tử đầu vào",
  MisaMeinvoiceMes: "Sao chép thông tin sau vào phần thiết lập thanh toán trên trang ",
  MisaCukCukLable: "MISA CukCuk",
  MisaCukCukDes: "Quản lý nhà hàng",
  MisaCukCukMes: "Sao chép thông tin sau vào phần thiết lập thẻ ngân hàng/ví điện tử trên trang ",
  WordpressLabel: "WordPress",
  WordpressDes: "Website bán hàng được xây dựng bằng WordPress và WooCommerce",
  DetectWordpress: "Làm thế nào để nhận biết?",
  WebsiteDiffirentLable: "Website, ứng dụng",
  WebsiteDiffirentLables: "Website, ứng dụng",
  WebsiteDiffirentDes: "Nền tảng quản lý bán hàng khác",
  LogoDes: "Logo được hiển thị trên trang thanh toán trực tuyến",
  Connect: "Kết nối",
  Instructions: "Xem hướng dẫn",
  InstructionsConnect: "Xem Tài liệu kết nối kỹ thuật ( tải về )",
  Your: "của bạn",
  WebhookTransactionQRCode: "Webhook thanh toán QR Code",
  Wordpress: {
    Title: "Kết nối cổng thanh toán JETPAY với Website WordPress",
    Save: "Lưu",
    Step1Title: "Cung cấp đường dẫn Website bán hàng của bạn",
    Step2Title: "Tải xuống Plug-in và cài đặt trên Website của bạn",
    Step3Title: "Sao chép các thông tin sau vào phần WooCommerce - JetPay để hoàn thành kết nối",
    Plugin: "Plug-in JETPAY",
    GuideDoc: "Hướng dẫn thiết lập",
  },
  ClientId: "ClientID (Mã Website)",
  ClientSecret: "ClientSecret (Khóa bảo mật Website)",
  CopyToast: "Đã sao chép {0}",
  AmisLabel: "AMIS Kế toán",
  AmisDes: "Phần mềm kế toán doanh nghiệp",
  AmisPopup: {
    Title: "Thiết lập kết nối AMIS Kế toán",
    AccessCodeTitle: "Mã kết nối của công ty",
    ConnectionSuccess: "Kết nối với AMIS Kế toán thành công!",
    ConnectionFailure: "Vui lòng nhập đúng Mã kết nối của công ty {0}!",
    SaveSuccess: "Lưu thông tin thành công",
    Save: "Lưu",
    Connected: "Đã kết nối",
    Disconnected: "Ngưng kết nối",
    AccesskeyIsExist: "Mã kết nối của công ty đã được sử dụng",
  },
  EMISKindergartenLabel: "Kết nối MISA EMIS Kindergarten",
  EMISKindergartenTitle: "Nền tảng quản lý trường mầm non",
  EMISKindergartenDesc:
    "Sao chép thông tin sau vào phần Cài đặt > Kết nối JETPAY Tuition trên ứng dụng MISA EMIS Kindergarten của bạn",
  EMISKindergarten: "MISA EMIS Kindergarten",
  EMISKindergartenMes:
    "Sao chép thông tin sau vào phần Cài đặt > Kết nối JETPAY Tuition trên ứng dụng MISA EMIS Kindergarten của bạn",
};
